(function () {
  'use strict';

  const instances = new WeakMap();

  function AbTestFaq(section) {
    this.section = section;
    this.mediaTrack = section.querySelector('.ab-test-faq__track--media');
    this.contentTrack = section.querySelector('.ab-test-faq__track--content');
    this.contentViewport = section.querySelector('.ab-test-faq__viewport--content');
    this.mediaSlides = Array.prototype.slice.call(section.querySelectorAll('.ab-test-faq__media-slide'));
    this.contentSlides = Array.prototype.slice.call(section.querySelectorAll('.ab-test-faq__content-slide'));
    this.dots = Array.prototype.slice.call(section.querySelectorAll('.ab-test-faq__dot'));
    this.index = 0;
    this.count = Math.max(this.mediaSlides.length, this.contentSlides.length);
    this.autoplay = section.dataset.autoplay === 'true';
    this.autoplaySpeed = (Number.parseInt(section.dataset.autoplaySpeed, 10) || 5) * 1000;
    this.enableSwipe = section.dataset.enableSwipe === 'true';
    this.timer = null;
    this.touchStartX = 0;
    this.touchDeltaX = 0;

    if (!this.mediaTrack || !this.contentTrack || this.count < 1) return;

    this.bind();
    this.goTo(0, false);
    this.startAutoplay();
  }

  AbTestFaq.prototype.bind = function () {
    this.onDotClick = (event) => {
      const slideIndex = Number.parseInt(event.currentTarget.dataset.slideIndex, 10);
      if (!Number.isNaN(slideIndex)) {
        this.goTo(slideIndex, true);
      }
    };

    this.onKeyDown = (event) => {
      if (event.key === 'ArrowRight') {
        event.preventDefault();
        this.goTo(this.index + 1, true);
      } else if (event.key === 'ArrowLeft') {
        event.preventDefault();
        this.goTo(this.index - 1, true);
      } else if (event.key === 'Home') {
        event.preventDefault();
        this.goTo(0, true);
      } else if (event.key === 'End') {
        event.preventDefault();
        this.goTo(this.count - 1, true);
      }
    };

    this.onPause = () => {
      this.stopAutoplay();
    };

    this.onResume = () => {
      this.startAutoplay();
    };

    this.dots.forEach((dot) => {
      dot.addEventListener('click', this.onDotClick);
    });

    if (this.contentViewport) {
      this.contentViewport.addEventListener('keydown', this.onKeyDown);
      this.contentViewport.addEventListener('mouseenter', this.onPause);
      this.contentViewport.addEventListener('mouseleave', this.onResume);
      this.contentViewport.addEventListener('focusin', this.onPause);
      this.contentViewport.addEventListener('focusout', this.onResume);
    }

    if (this.enableSwipe) {
      this.onTouchStart = (event) => {
        this.touchStartX = event.touches[0].clientX;
        this.touchDeltaX = 0;
      };

      this.onTouchMove = (event) => {
        this.touchDeltaX = event.touches[0].clientX - this.touchStartX;
      };

      this.onTouchEnd = () => {
        if (Math.abs(this.touchDeltaX) < 40) return;
        if (this.touchDeltaX < 0) this.goTo(this.index + 1, true);
        else this.goTo(this.index - 1, true);
      };

      [this.mediaTrack, this.contentTrack].forEach((track) => {
        track.addEventListener('touchstart', this.onTouchStart, { passive: true });
        track.addEventListener('touchmove', this.onTouchMove, { passive: true });
        track.addEventListener('touchend', this.onTouchEnd, { passive: true });
      });
    }
  };

  AbTestFaq.prototype.goTo = function (index, userInitiated) {
    if (!this.count) return;

    if (index < 0) index = this.count - 1;
    if (index >= this.count) index = 0;

    this.index = index;
    this.mediaTrack.style.transform = 'translate3d(-' + (index * 100) + '%, 0, 0)';
    this.contentTrack.style.transform = 'translate3d(-' + (index * 100) + '%, 0, 0)';

    this.mediaSlides.forEach((slide, slideIndex) => {
      slide.setAttribute('aria-hidden', slideIndex === index ? 'false' : 'true');
    });

    this.contentSlides.forEach((slide, slideIndex) => {
      slide.setAttribute('aria-hidden', slideIndex === index ? 'false' : 'true');
    });

    this.dots.forEach((dot, dotIndex) => {
      const isActive = dotIndex === index;
      dot.classList.toggle('is-active', isActive);
      dot.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });

    if (userInitiated) {
      this.stopAutoplay();
      this.startAutoplay();
    }
  };

  AbTestFaq.prototype.startAutoplay = function () {
    if (!this.autoplay || this.count < 2) return;

    this.stopAutoplay();
    this.timer = globalThis.setInterval(() => {
      this.goTo(this.index + 1, false);
    }, this.autoplaySpeed);
  };

  AbTestFaq.prototype.stopAutoplay = function () {
    if (this.timer) {
      globalThis.clearInterval(this.timer);
      this.timer = null;
    }
  };

  AbTestFaq.prototype.destroy = function () {
    this.stopAutoplay();

    this.dots.forEach((dot) => {
      dot.removeEventListener('click', this.onDotClick);
    });

    if (this.contentViewport) {
      this.contentViewport.removeEventListener('keydown', this.onKeyDown);
      this.contentViewport.removeEventListener('mouseenter', this.onPause);
      this.contentViewport.removeEventListener('mouseleave', this.onResume);
      this.contentViewport.removeEventListener('focusin', this.onPause);
      this.contentViewport.removeEventListener('focusout', this.onResume);
    }

    if (this.enableSwipe) {
      [this.mediaTrack, this.contentTrack].forEach((track) => {
        track.removeEventListener('touchstart', this.onTouchStart);
        track.removeEventListener('touchmove', this.onTouchMove);
        track.removeEventListener('touchend', this.onTouchEnd);
      });
    }
  };

  function initSection(section) {
    if (!section) return;

    const existing = instances.get(section);
    if (existing) {
      existing.destroy();
    }

    instances.set(section, new AbTestFaq(section));
  }

  function boot(root) {
    (root || document).querySelectorAll('[data-ab-test-faq]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      boot(document);
    });
  } else {
    boot(document);
  }

  document.addEventListener('shopify:section:load', (event) => {
    boot(event.target);
  });

  document.addEventListener('shopify:section:unload', (event) => {
    const section = event.target?.querySelector('[data-ab-test-faq]');
    const instance = section ? instances.get(section) : null;
    if (instance) {
      instance.destroy();
      instances.delete(section);
    }
  });

  document.addEventListener('shopify:block:select', (event) => {
    const block = event.target;
    const section = block?.closest('[data-ab-test-faq]') ?? null;
    const slide = block?.closest('.ab-test-faq__content-slide') ?? null;
    const instance = section ? instances.get(section) : null;
    const slideIndex = slide ? Number.parseInt(slide.dataset.slideIndex, 10) : Number.NaN;

    if (instance && !Number.isNaN(slideIndex)) {
      instance.goTo(slideIndex, true);
    }
  });
})();